import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  IESDPCaptainReports,
  IESDPFreeTimeGraph,
  IESDPGroupTeams,
  IESDPIterationReview,
  IESDPTeam,
  IESDPTeamDocument,
  IESDPTeamDocuments,
  IESDPTeamIteration,
  IESDPTeamMaterials,
  IESDPTeams,
} from '@interfaces/IESDP';
import { IESDPIterationsQParams } from '@interfaces/IQParams';
import { IUsersPagination } from '@interfaces/IUser';
import { getHttpParams } from '@shared/utils/utils';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ESDPViewService {
  constructor(private _http: HttpClient) {}

  getTeam(id: number): Observable<IESDPTeam> {
    const url = `${environment.baseUrl}api/v1/teams/${id}/`;
    return this._http.get<IESDPTeam>(url);
  }

  getTeams(qParams?: {
    [key: string]: number | boolean;
  }): Observable<IESDPGroupTeams[]> {
    const url = `${environment.baseUrl}api/v1/teams/`;
    return this._http.get<IESDPGroupTeams[]>(url, { params: qParams });
  }

  generateTeams(qParams: { [key: string]: number }): Observable<IESDPTeams[]> {
    const url = `${environment.baseUrl}api/v1/teams/preliminary/`;
    return this._http.get<IESDPTeams[]>(url, { params: qParams });
  }

  getFreeTimeGraph(id: number): Observable<IESDPFreeTimeGraph> {
    const url = `${environment.baseUrl}api/v1/free-time-forms/${id}/`;
    return this._http.get<IESDPFreeTimeGraph>(url);
  }

  getIterations(
    qParams?: IESDPIterationsQParams
  ): Observable<IESDPTeamIteration[]> {
    const url = `${environment.baseUrl}api/v1/iterations/`;
    let params = new HttpParams();

    if (qParams) {
      params = getHttpParams({ ...qParams });
    }

    return this._http.get<IESDPTeamIteration[]>(url, { params });
  }

  getIterationById(id: number): Observable<IESDPTeamIteration> {
    const url = `${environment.baseUrl}api/v1/iterations/${id}/`;
    return this._http.get<IESDPTeamIteration>(url);
  }

  getIterationReviewById(id: number): Observable<IESDPIterationReview> {
    const url = `${environment.baseUrl}api/v1/iteration-reviews/${id}/`;
    return this._http.get<IESDPIterationReview>(url);
  }

  getTeamStudents(
    teamId: number,
    qParams?: { status: string }
  ): Observable<IUsersPagination> {
    const url = `${environment.baseUrl}api/v1/teams/${teamId}/students/`;
    return this._http.get<IUsersPagination>(url, { params: qParams });
  }

  getTeamMentors(
    teamId: number,
    qParams?: { status: string }
  ): Observable<IUsersPagination> {
    const url = `${environment.baseUrl}api/v1/teams/${teamId}/mentors/`;
    return this._http.get<IUsersPagination>(url, { params: qParams });
  }

  getTeamDocuments(qParams?: {
    team_id: number;
  }): Observable<IESDPTeamDocuments> {
    const url = `${environment.baseUrl}api/v1/team-documents/`;
    return this._http.get<IESDPTeamDocuments>(url, { params: qParams });
  }

  getTeamDocumentById(id: number): Observable<IESDPTeamDocument> {
    const url = `${environment.baseUrl}api/v1/team-documents/${id}/`;
    return this._http.get<IESDPTeamDocument>(url);
  }

  getTeamMaterials(team_id: number): Observable<IESDPTeamMaterials[]> {
    const url = `${environment.baseUrl}api/v1/teams/${team_id}/files/`;
    return this._http.get<IESDPTeamMaterials[]>(url);
  }
  getIterationCaptainReports(
    id: number,
    qParams?: { status: string }
  ): Observable<IESDPCaptainReports> {
    const url = `${environment.baseUrl}api/v1/iterations/${id}/captain-reports/`;
    return this._http.get<IESDPCaptainReports>(url, { params: qParams });
  }
}
